import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { getHsUid, clearHsToken } from "../pages/happyschool_static/hsAuth";

// Thanh điều hướng mới, KHÔNG Firebase — thay cho Navigation.js/LeftMenuAntd.js
// (đã xoá cùng Resshare, cả 2 đều cần Firebase cho đăng nhập Google).
const barStyle = {
  display: "flex",
  alignItems: "center",
  gap: 20,
  padding: "12px 24px",
  background: "#0f172a",
  color: "#fff",
  flexWrap: "wrap",
};

const linkStyle = {
  color: "#e2e8f0",
  textDecoration: "none",
  fontSize: 14,
};

const brandStyle = {
  ...linkStyle,
  fontWeight: 800,
  fontSize: 16,
  marginRight: 12,
};

const links = [
  { to: "/happyschool", label: "HappySchool" },
  { to: "/quiz3", label: "Quiz3" },
  { to: "/policy", label: "Policy" },
  { to: "/child-safety-standards", label: "Child Safety Standards" },
];

const buttonLinkStyle = {
  ...linkStyle,
  background: "none",
  border: "none",
  cursor: "pointer",
  padding: 0,
  font: "inherit",
};

const TopNav = () => {
  const navigate = useNavigate();
  const loggedIn = !!getHsUid();

  const handleLogout = () => {
    clearHsToken();
    navigate("/login");
  };

  return (
    <nav style={barStyle}>
      <Link to="/" style={brandStyle}>Saolait</Link>
      {links.map((l) => (
        <Link key={l.to} to={l.to} style={linkStyle}>{l.label}</Link>
      ))}
      {loggedIn ? (
        <button type="button" onClick={handleLogout} style={buttonLinkStyle}>Đăng xuất</button>
      ) : (
        <Link to="/login" style={linkStyle}>Đăng nhập</Link>
      )}
    </nav>
  );
};

export default TopNav;
